import { Component, ViewChild, OnInit, Input } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalSchedulerGraphicComponent } from 'src/app/components/ui/modal-scheduler-graphic/modal-scheduler-graphic.component';
import { ModalService } from 'src/app/services/modal/modal.service';
import { AstCalendarService } from 'src/app/services/sunTimes/suntimes.service';
import { SuntimesService } from 'src/app/services/sunTimes/sunTimesLegacy.service';
import { SchedulerAncComponent } from 'src/app/components/scheduler-anc/scheduler-anc.component';
import { DeviceService } from 'src/app/services/devices/device.service';
import { AncDataService } from 'src/app/services/ANC/anc-data.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

import { ANCModelResolved } from 'src/app/services/ANC/anc-data.service';
import dataPrograms from './data';



@Component({
    selector: 'app-anc1',
    templateUrl: './anc1.component.html',
    styleUrl: './anc1.component.scss',
    standalone: false
})
export class ANC1Component implements OnInit  {

  @Input() serial: string = '';
  @ViewChild(SchedulerAncComponent) schedulerAnc?: SchedulerAncComponent;

  data = dataPrograms;
  selectedOutput: number = 1;
  sunTimesData: any[] = [];
  hideSchedulerAnc = false;

  modalScheduler?: NgbModalRef;

  deviceInfo: any = {};
  ancDeviceInfo: any = {};
  scheduleInfo: any = {};
  programsInfo: any[] = [];
  programDataFormated: any[] = [];
  channelInfo: any = {};
  holidayInfo: any = {};
  calendarInfo: any = {};
  orgianalChannelInfo: any = {};
  ubicacion: any ={}
  coordenadas: { latitude: number; longitude: number; gmtWinter?: number | null; gmtSummer?: number | null; gmtWinterMinutes?: number | null; gmtSummerMinutes?: number | null } | null = null;
  gmtMinutes: number | null = null;



  constructor(private _modal: ModalService, private astCalendarService: AstCalendarService, private _device: DeviceService,
   private _ancDataService: AncDataService, private suntimesService: SuntimesService, private _util: UtilsService) { }

  ngOnInit(): void {

    this._device.getModuleInfo(this.serial, 'device').subscribe(deviceInfo => {
      this.ancDeviceInfo = deviceInfo.cfg;
      console.log('ANC DEVICE', this.ancDeviceInfo );

         this._device.getDeviceInfo(this.serial).subscribe(deviceInfo => {
            this.deviceInfo = deviceInfo;
            const version = deviceInfo.hardware_version.split('.').pop() ?? '';
            this.coordenadas = this._ancDataService.getLocation(version, this.ancDeviceInfo.country, this.ancDeviceInfo.city);
            // console.log('coordenadas ', this.coordenadas);
            this.ubicacion = this._ancDataService.getCountryCityNames(version, this.ancDeviceInfo.country, this.ancDeviceInfo.city);
            // console.log('ubicacion ', this.ubicacion);

            // Determinar si es horario de verano (DST) - simplificado: marzo a octubre
            const now = new Date();
            const isDST = now.getMonth() >= 2 && now.getMonth() <= 9; // 0-based: 2=marzo, 9=octubre
            const tzOffsetMinutes = isDST ? (this.coordenadas?.gmtSummerMinutes ?? (-new Date().getTimezoneOffset())) : (this.coordenadas?.gmtWinterMinutes ?? (-new Date().getTimezoneOffset()));
            this.gmtMinutes = tzOffsetMinutes;
            // console.log(tzOffsetMinutes, 'tzOffsetMinutes -----');

            this.sunTimesData = this.suntimesService.calculateSuntimesLegacyForWeek(
              new Date(),
              tzOffsetMinutes,
              this.coordenadas?.latitude ?? 0,
              this.coordenadas?.longitude ?? 0
            );
            // this.calendarInfo.corrSunrise = -130;
            // this.calendarInfo.corrSunset = 0

            console.log('sunTimesData para 7 dias /////////', this.sunTimesData);
            this.addCorrectionToSunTimes();
            console.log('sunTimesData para 7 dias  corregido /////////', this.sunTimesData);
            console.log('sunTimesData para hoy -----', this.sunTimesData[0]);


         });
    });



    this._device.getModuleInfo(this.serial, 'schedule').subscribe(scheduleInfo => {
      console.log('Schedule Info:', scheduleInfo);
      this.scheduleInfo = scheduleInfo;

      if (scheduleInfo?.cfg?.programs) {
      this.programsInfo = JSON.parse(scheduleInfo?.cfg?.programs) || [];
      console.log('programas ', this.programsInfo);
    }

      console.log('programans ', this.data);

      this.programDataFormated = this.formatProgramData(this.programsInfo);
      this.programDataFormated = this.formatProgramData(this.data);
      console.log('programas formateados ', this.programDataFormated);

    });

    this._device.getModuleInfo(this.serial, 'channel').subscribe(channelInfo => {
      console.log('Channel Info:', channelInfo);
      this.channelInfo = channelInfo;
      this.orgianalChannelInfo = JSON.parse(JSON.stringify(channelInfo));
    });

    this._device.getModuleInfo(this.serial, 'holiday').subscribe(holidayInfo => {
      console.log('Holiday Info:', holidayInfo);
      this.holidayInfo = holidayInfo.cfg;
    });

  }

  addCorrectionToSunTimes() {
        this._device.getModuleInfo(this.serial, "calendar").subscribe(data=>{
          this.calendarInfo = data.cfg;
          console.log('Calendar Info for corrections:', this.calendarInfo);
          if (this.calendarInfo.corrSunrise !== undefined && this.calendarInfo.corrSunset !== undefined) {
            const corrSunriseMinutes = this.calendarInfo.corrSunrise;
            const corrSunsetMinutes = this.calendarInfo.corrSunset;
            console.log('Correction object:', { corrSunriseMinutes, corrSunsetMinutes });

            this.sunTimesData = this.sunTimesData.map(day => {
              return {
                ...day,
                sunriseMin: day.sunriseMin + corrSunriseMinutes,
                sunriseStr: this._util.getDateFromMinutes(day.sunriseMin + corrSunriseMinutes),
                sunsetMin: day.sunsetMin + corrSunsetMinutes,
                sunsetStr: this._util.getDateFromMinutes(day.sunsetMin + corrSunsetMinutes)
              };
            });
          }
        });
  }

  // Función para formatear la última conexión
  formatLastSeen(lastseen: string): string {
    if (!lastseen) return 'Nunca';
    const date = new Date(lastseen);
    return date.toLocaleString('es-ES');
  }

  // Función para manejar el cambio de salida desde los botones
  onOutputChange(output: number): void {
    this.selectedOutput = output;
    console.log('Selected output in ANC1:', output);
  }

  // Obtener el objeto de programaciones para el scheduler-anc
  getSchedulerData(): any {
    // return this.data.scheduler || {};
    console.log(' Scheduler data for ANC1:', this.programDataFormated);
    return this.programDataFormated
  }

  // Función para abrir el modal de programación
  openSchedulerModal(): void {
    // Hide the background scheduler component to avoid canvas/icon overlap
    this.hideSchedulerAnc = true;

    // If we have a reference to the scheduler component, ask it to pause rendering
    try {
      this.schedulerAnc?.pauseRendering();
    } catch (e) {
      console.warn('Failed to pause schedulerAnc rendering', e);
    }

    const modalRef = this._modal.open(ModalSchedulerGraphicComponent, {
      centered: true,
      scrollable: true,
      windowClass: 'scheduler-window' // clase que usarás en el CSS
    });

    modalRef.componentInstance.schedulerData = this.getSchedulerData();
    modalRef.componentInstance.selectedOutput = this.selectedOutput;
    // modalRef.componentInstance.deviceData = this.data;
    // Pass sunTimesData (calculated array with real astronomical data)
    modalRef.componentInstance.sunTimes = this.sunTimesData;

    modalRef.result.then(
      (result) => {
        // Modal closed with save
        console.log('Modal cerrado con resultado:', result);
        this.hideSchedulerAnc = false;
        try {
          this.schedulerAnc?.resumeRendering();
        } catch (e) {
          console.warn('Failed to resume schedulerAnc rendering', e);
        }
      },
      () => {
        // Modal dismissed without save
        console.log('Modal cerrado sin cambios');
        this.hideSchedulerAnc = false;
        try {
          this.schedulerAnc?.resumeRendering();
        } catch (e) {
          console.warn('Failed to resume schedulerAnc rendering', e);
        }
      }
    );
  }


  changeOutput(output: number) {
    switch (output) {
      case 1:
        if (this.channelInfo?.stat?.c1stat == 2 ){
          this.channelInfo.stat.c1stat = 1
        }else if (this.channelInfo?.stat?.c1stat == 3){
          this.channelInfo.stat.c1stat = 0
        }else if  (this.channelInfo?.stat?.c1stat == 0){
          this.channelInfo.stat.c1stat = 3
        }else{
          this.channelInfo.stat.c1stat = 2
        }
        break;
      case 2:
        if (this.channelInfo?.stat?.c2stat == 2 ){
          this.channelInfo.stat.c2stat = 1
        }else if (this.channelInfo?.stat?.c2stat == 3){
          this.channelInfo.stat.c2stat = 0
        }else if  (this.channelInfo?.stat?.c2stat == 0){
          this.channelInfo.stat.c2stat = 3
        }else{
          this.channelInfo.stat.c2stat = 2
        }
        break;
      default:
        break;
    }
  }

  changePermanentOutput(output: number, permanent: boolean) {

    switch (this.ancDeviceInfo.permanent) {
      case 1: // salida 1 permanente
        if (output === 1 && !permanent) {
          this.ancDeviceInfo.permanent = 0; // quitar permanente salida 1
        }
        if (output === 2 && permanent) {
          this.ancDeviceInfo.permanent = 3; // hacer permanentes ambas salidas
        }
        break;
      case 2: // salida 2 permanente
        if (output === 2 && !permanent) {
          this.ancDeviceInfo.permanent = 0; // quitar permanente salida 2
        }
        if (output === 1 && permanent) {
          this.ancDeviceInfo.permanent = 3; // hacer permanentes ambas salidas
        }
        break;
      case 3: // ambas salidas permanentes
        if (output === 1 && !permanent) {
          this.ancDeviceInfo.permanent = 2; // quitar permanente salida 1
        }
        if (output === 2 && !permanent) {
          this.ancDeviceInfo.permanent = 1; // quitar permanente salida 2
        }
        break;
      case 0: // ninguna salida permanente
        if (output === 1 && permanent) {
          this.ancDeviceInfo.permanent = 1; // hacer permanente salida 1
        }
        if (output === 2 && permanent) {
          this.ancDeviceInfo.permanent = 2; // hacer permanente salida 2
        }
        break;
        default:
        break;
    }

  }


  formatProgramData(programData: any): any[] {
    return this._ancDataService.formatProgramData(programData);
  }
}

// ***** Programas *****

// Byte	            Campo	Descripción

// 0–3                 ime	0..1439 minutos para hora fija, o -599..599 para corrección astronómica
// 4	                 id	0 (P1) … 39 (P40), identificador de programa (máximo 40 programas)
// 5	                 channel	0=none, 1=C1, 2=C2, 3=C1+C2
// 6	                 type	0=Off, 1=On, 2=Pulse, 3=Cycle
// 7	                 mode	1=ocaso, 2=orto, 4=ini_reduc, 8=fin_reduc, 16=hora_fija
// 8	                 daymask	bit6=lunes .. bit0=domingo
// 9	                 festive	0=sin festivos, 1–4=periodo activo
// 10–18	             auxdata	Para programas tipo pulso/ciclo):
// - auxdata[0]:       Pulso: duración en segundos; Ciclo: daymask fin
// - auxdata[1..2]:    Ciclo: hora de fin en minutos
// - auxdata[3..5]:    Ciclo: tiempo ON en segundos
// - auxdata[6..8]:    Ciclo: tiempo OFF en segundos

